import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import React from 'react';
import { Observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { DownloadLayer } from '../../transportLayers/DownloadLayer';
import Modal from '../../../components/info/Modal';
import ProgressBar from '../../../components/info/ProgressBar';
import translate from '../../../components/i18n/translate';
/**
 * Contains methods and state variables for simple file download (from /download endpoint)
 *
 * @author Jan Prokop
 */

export var DownloadStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(DownloadStore, _BaseStore);

  function DownloadStore() {
    var _this;

    _classCallCheck(this, DownloadStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DownloadStore).apply(this, arguments));
    _this.name = StoreName.Download;
    _this.downloadLayer = new DownloadLayer();
    _this.downloading = false;
    return _this;
  }
  /**
   * Downloads specified file by its name.
   *
   * @param filename
   */


  _createClass(DownloadStore, [{
    key: "download",
    value: function download(filename) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.downloading) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", Promise.reject(new Error('file-download_another-download')));

              case 2:
                this.length = 0;
                this.downloaded = 0;
                this.filename = filename;
                this.downloading = true;
                this.error = null;
                _context.prev = 7;
                _context.next = 10;
                return this.downloadLayer.download(filename, this.onProgress, function (cancel) {
                  return _this2._cancel = cancel;
                });

              case 10:
                res = _context.sent;
                this.finish();
                return _context.abrupt("return", res);

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](7);
                this.finish(_context.t0);
                return _context.abrupt("return", this.handleCatchError(_context.t0, 'download'));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 15]]);
      }));
    }
    /**
     * Cancels current downloading.
     *
     * @param msg
     */

  }, {
    key: "cancel",
    value: function cancel() {
      if (this._cancel) {
        this._cancel('file-download_aborted-by-user');
      }
    }
  }, {
    key: "onProgress",
    value: function onProgress(loaded, total) {
      this.length = total;
      this.downloaded = loaded;
    }
  }, {
    key: "finish",
    value: function finish() {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.downloading = false;
      this._cancel = null;
      this.error = err;
    }
    /**
     * Render standard download modal.
     */

  }, {
    key: "renderModal",
    value: function renderModal() {
      var _this3 = this;

      return React.createElement(Observer, null, function () {
        return React.createElement(Modal, {
          hidden: !_this3.downloading,
          close: _this3.cancel,
          title: _this3.filename
        }, _this3.length ? React.createElement(ProgressBar, {
          label: translate('file-download_downloading'),
          percentage: Math.round(_this3.downloaded / _this3.length * 100)
        }) : React.createElement(ProgressBar, {
          label: translate('file-download_preparing'),
          percentage: 0
        }));
      });
    }
  }]);

  return DownloadStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Object)], DownloadStore.prototype, "downloading", void 0);

__decorate([observable, __metadata("design:type", String)], DownloadStore.prototype, "filename", void 0);

__decorate([observable, __metadata("design:type", Number)], DownloadStore.prototype, "length", void 0);

__decorate([observable, __metadata("design:type", Number)], DownloadStore.prototype, "downloaded", void 0);

__decorate([observable, __metadata("design:type", Object)], DownloadStore.prototype, "error", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], DownloadStore.prototype, "download", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], DownloadStore.prototype, "cancel", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Number]), __metadata("design:returntype", void 0)], DownloadStore.prototype, "onProgress", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], DownloadStore.prototype, "finish", null);